import React from 'react';
import PropTypes from 'prop-types';
import shouldUpdate from 'recompose/shouldUpdate';
import { TableBody, TableRow } from 'material-ui/Table';
import DatagridCell from 'admin-on-rest/lib/mui/list/DatagridCell';

/**
 * The DatagridBodyName component duplicates the AOR DatagridBody, which renders a list of records as a table.
 * It handles the list by name instead of id.
 *
 */
const DatagridBodyName = ({
    resource,
    children,
    ids,
    isLoading,
    data,
    basePath,
    styles,
    rowStyle,
    options,
    rowOptions,
    ...rest
}) => (
    <TableBody
        displayRowCheckbox={false}
        className="datagrid-body"
        {...rest}
        {...options}
    >
        {ids.map((name, rowIndex) => (
            <TableRow
                style={rowStyle ? rowStyle(data[name], rowIndex) : styles.tr}
                key={name + rowIndex}
                selectable={false}
                {...rowOptions}
            >
                {React.Children.map(
                    children,
                    (field, index) =>
                        field ? (
                            <DatagridCell
                                key={`${name}-${(field.props.source + '-' + index) || index}`}
                                className={`column-${field.props.source}`}
                                record={data[name]}
                                defaultStyle={
                                    index === 0 ? (
                                        styles.cell['td:first-child']
                                    ) : (
                                        styles.cell.td
                                    )
                                }
                                {...{ field, basePath, resource }}
                            />
                        ) : null
                )}
            </TableRow>
        ))}
    </TableBody>
);

DatagridBodyName.propTypes = {
    ids: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool,
    resource: PropTypes.string,
    data: PropTypes.object.isRequired,
    basePath: PropTypes.string,
    options: PropTypes.object,
    rowOptions: PropTypes.object,
    styles: PropTypes.object,
    rowStyle: PropTypes.func,
};

DatagridBodyName.defaultProps = {
    data: {},
    ids: [],
};

const PureDatagridBodyName = shouldUpdate(
    (props, nextProps) => nextProps.isLoading === false
)(DatagridBodyName);

// trick material-ui Table into thinking this is one of the child type it supports
PureDatagridBodyName.muiName = 'TableBody';

export default PureDatagridBodyName;



// WEBPACK FOOTER //
// ./src/Fuse/admin/DatagridBodyName.js